import type { FC } from 'react'
import React from 'react'

import { FlexPrivate } from './flex'
import type { FlexProps } from './types'
import type { PrivateThemeUiProps } from '../../../styles-system/create-component'

export const FlexInlinePrivate: FC<FlexProps & PrivateThemeUiProps> =
  React.forwardRef<HTMLDivElement, FlexProps & PrivateThemeUiProps>(
    function FlexInlinePrivate(props, ref) {
      return <FlexPrivate ref={ref} {...props} inline />
    }
  )

const FlexInline: FC<FlexProps> = React.forwardRef<HTMLDivElement, FlexProps>(
  function FlexInline(props, ref) {
    return <FlexInlinePrivate ref={ref} {...props} />
  }
)

export default FlexInline
